import { render, staticRenderFns } from "./move-show.vue?vue&type=template&id=f2b441ce"
import script from "./move-show.vue?vue&type=script&lang=js"
export * from "./move-show.vue?vue&type=script&lang=js"
import style0 from "./move-show.vue?vue&type=style&index=0&id=f2b441ce&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gobo-app/gobo-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2b441ce')) {
      api.createRecord('f2b441ce', component.options)
    } else {
      api.reload('f2b441ce', component.options)
    }
    module.hot.accept("./move-show.vue?vue&type=template&id=f2b441ce", function () {
      api.rerender('f2b441ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/move-show.vue"
export default component.exports